import {
    SAVE_CONSIGNMENT_ADD_DETAILS,
    SAVE_CONSIGNMENT_ADD_DETAILS_SUCCESS,
    SAVE_CONSIGNMENT_ADD_DETAILS_FAILURE,
    RESET_CREATECONSIGNMENT_ADD,
} from '../actions/actionTypes';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    saveconsignmentAdd: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    saveconsignmentAddLoading: false,
};

const createConsignmentAddReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_CONSIGNMENT_ADD_DETAILS:
            return {
                ...state,
                saveconsignmentAddLoading: true,
            };
        case SAVE_CONSIGNMENT_ADD_DETAILS_SUCCESS:
            return {
                ...state,
                saveconsignmentAdd: {
                    data: action.data,
                    statusCode: '10011',
                },
                saveconsignmentAddLoading: false,
            };
        case SAVE_CONSIGNMENT_ADD_DETAILS_FAILURE:
            return {
                ...state,
                saveconsignmentAdd: {
                    data: {},
                    message: action.data.message,
                    statusCode: '422',
                },
                saveconsignmentAddLoading: false,
            };
        case RESET_CREATECONSIGNMENT_ADD:
            return initialState;
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'createConsignmentAddKey',
        storage: storage,
    },
    createConsignmentAddReducer
);
